import { PlayerPhysicalPerformance } from "@/services/player-physical-performance-service.js";

export async function checkIfMinsStatsDataExists(
  matchDate,
  gameType,
  responseType,
  playerId,
  selectedGame,
) {
  try {
    const data = {
      action: "getPlayerMinsPerformanceDataForDate",
      session_date: matchDate,
      player_id: playerId,
    };

    const response = await PlayerPhysicalPerformance.find(data);

    if (response.data !== false) {
      if (responseType === "No") {
        // If the response is "No", delete the existing data
        await deleteDayMinsStatsData(response.data.id);
      } else {
        // If the response is "Yes", update the existing data
        await editDayMinsStatsData(
          matchDate,
          gameType,
          responseType,
          playerId,
          response.data.id,
          selectedGame,
        );
      }
    } else {
      await addDayMinsStatsData(
        matchDate,
        gameType,
        responseType,
        playerId,
        selectedGame,
      );
    }
  } catch (error) {
    console.error("Error in checkIfMinsStatsDataExists:", error);
  }
}

async function editDayMinsStatsData(
  matchDate,
  gameType,
  responseType,
  playerId,
  minId,
  selectedGame,
) {
  const sessionMins =
    responseType === "Yes" ? (gameType === "Training" ? 75 : 90) : 0;

  const data = {
    action: "editDayMinsStatsData",
    id: minId,
    player_id: playerId,
    session_date: matchDate,
    session_type: gameType,
    session_mins: sessionMins,
    playing_down_level: 0,
    playing_up_level: 0,
    session_distance: 0,
    total_absolute_high_speed_distance: 0,
    maximum_velocity: 0,
    max_vel_max: 0,
    accelerations_total_efforts: 0,
    decelerations_total_efforts: 0,
    meterage_per_minute: 0,
    gameId: selectedGame.id,
    teamId: selectedGame.teamId,
  };

  try {
    await PlayerPhysicalPerformance.find(data);
  } catch (error) {
    console.error("Error in editDayMinsStatsData:", error);
  }
}

async function addDayMinsStatsData(
  matchDate,
  gameType,
  responseType,
  playerId,
  selectedGame,
) {
  const sessionMins =
    responseType === "Yes" ? (gameType === "Training" ? 75 : 90) : 0;

  const data = {
    action: "addDayMinsStatsData",
    data: {
      player_id: playerId,
      session_date: matchDate,
      session_type: gameType,
      session_mins: sessionMins,
      playing_down_level: 0,
      playing_up_level: 0,
      session_distance: 0,
      total_absolute_high_speed_distance: 0,
      maximum_velocity: 0,
      max_vel_max: 0,
      accelerations_total_efforts: 0,
      decelerations_total_efforts: 0,
      meterage_per_minute: 0,
      gameId: selectedGame.id,
      teamId: selectedGame.teamId,
    },
  };

  try {
    await PlayerPhysicalPerformance.find(data);
  } catch (error) {
    console.error("Error in addDayMinsStatsData:", error);
  }
}

async function deleteDayMinsStatsData(id) {
  const data = {
    action: "deleteDayMinsStatsData",
    id: id,
  };

  try {
    await PlayerPhysicalPerformance.find(data);
  } catch (error) {
    console.error("Error in deleteDayMinsStatsData:", error);
  }
}
